import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const FormSection = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.custom?.stroke || '#D7D9D6'}`,
  borderRadius: '16px',
  padding: '20px',
}));

export default FormSection;
